<template>
  <section class="hero is-fullheight-with-navbar">
    <!-- <section class="section"> -->
    <div class="hero-body" style="align-items: flex-start">
      <div class="container">
        <div class="columns">
          <div class="column is-6">
            <h2 class="subtitle has-text-weight-bold">
              Е-паркинг
            </h2>
            <div class="buttons" v-show="false">
              <b-button
                type="is-dnevna"
                tag="router-link"
                :to="{
                  path: '/kupovina',
                  query: { step: '0', vrsta_karte: 'DK' }
                }"
                >E-дневна паркинг карта</b-button
              >
              <b-button
                tag="router-link"
                :to="{
                  path: '/kupovina',
                  query: { step: '0', vrsta_karte: 'PK' }
                }"
                >E-месечна претплата</b-button
              >
            </div>

            <Najvaznije type="vest" title="Актуелне вести" count="4" />
          </div>
          <div class="column is-6">
            <div style="margin-bottom: 8px">
              <a
                target="_blank"
                href="http://portal.ujn.gov.rs/RezultatiPretrage.aspx?tab=1&pocetna=1&tp=F1KlmN+JuNI=&nnar=L30q2awNCIlbwjqeJvmvImKt2DlIUi7agCC0BFqj3t8cT8tluuKCw2/kQOT0d+CEOnlsgdIIqsDxkovq1dvZ3bui6iKzMDft"
                ><span class="">Портал јавних набвки</span>
              </a>
            </div>

            <Najvaznije type="javna-nabavka" title="Јавне набавке" count="4" />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import Najvaznije from '@/components/Najvaznije.vue'
import Footer from '@/components/Footer.vue'
import { baseUrl } from '@/conf'

export default {
  name: 'Home',
  components: {
    // HelloWorld
    Najvaznije,
    Footer
  },
  data() {
    return {}
  },
  methods: {
    getImgUrl(i) {
      // produkcija
      //return '/slajd' + i + '.jpg'
      // development
      return baseUrl + '/slajd' + i + '.jpg'
    }
  }
}
</script>

<style>
.imageCss {
  max-width: 400px;
}
</style>
